import { ReactElement } from "react";

import { RolePermission } from "../../graphql/generated.ts";
import Page404 from "../../pages/404/Page404.tsx";
import { useCurrentUserContext } from "../../providers/CurrentUserProvider.tsx";
import { hasPermission, isBababosTenant } from "../../utils/user.ts";
import Preloader from "../Preloader/Preloader.tsx";

interface Props {
  children: ReactElement;
  permission: RolePermission;
  bababosTenantOnly?: boolean;
}

export const HasAccessGuard = ({
  children,
  permission,
  bababosTenantOnly = false,
}: Props) => {
  const { fetching, user } = useCurrentUserContext();

  const hasAccess = hasPermission(user, permission);

  if (fetching) {
    return <Preloader loading={true} />;
  }

  if (!hasAccess || (bababosTenantOnly && !isBababosTenant(user))) {
    return <Page404 />;
  }

  return children;
};
